import { PatchResultBase } from "./PatchResultBase.js";

export class PatchResult extends PatchResultBase {
    public originalDocument: object;
    public debug: object;
}
